import * as React from 'react'

import { Box, Skeleton } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

const Year = () => {
  return (
    <Box paddingY="s32" flexDirection="row" justifyContent="center" alignItems="center">
      <Skeleton width="s80" height="s24" />
    </Box>
  )
}

const DayRows = () => {
  return (
    <Box className={styles.grid} gap="s8">
      <Skeleton width="full" height="s16" />
      <Skeleton width="full" height="s16" />
      <Skeleton width="full" height="s16" />
      <Skeleton width="s80" height="s16" />
    </Box>
  )
}
const Month = () => {
  return (
    <li className={styles.month}>
      <Box className={styles.title}>
        <Skeleton width="s96" height="full" />
      </Box>
      <Box gap="s8">
        <Skeleton width="full" height="s16" />
        <DayRows />
      </Box>
    </li>
  )
}

const Months = () => {
  const numMonths = 12
  const months = Array.from({ length: numMonths }, (_, index) => index + 1)

  return (
    <Box paddingX="s32">
      <ul className={styles.months}>
        {months.map((_, index) => (
          <Month key={`month_${index}`} />
        ))}
      </ul>
    </Box>
  )
}

const Legend = () => {
  return (
    <Box paddingX="s32" paddingBottom="s24" flexDirection="row" gap="s8">
      <Skeleton width="s80" height="s24" />
      <Skeleton width="s80" height="s24" />
      <Skeleton width="s140" height="s24" />
      <Skeleton width="s120" height="s24" />
    </Box>
  )
}

const SkeletonLoader = () => {
  return (
    <>
      <Year />
      <Months />
      <Legend />
    </>
  )
}

export default SkeletonLoader
